// The text of a UiMessage of the catalogue (RN75): its key with its params, and the second sentence when it has one. The params
// named in `translate` are keys of the catalogue themselves (the label of a filter, of a table or of a status, story 211) and
// are translated before being inserted; the others go as they are (ids, names, the `cause` of Sun).
export const messageText = (message, t_) => {
  const params = { ...(message.params || {}) }
  ;(message.translate || []).forEach((name) => { params[name] = t_(params[name]) })
  return [t_(message.key, params), message.extra && t_(message.extra.key, message.extra.params)].filter(Boolean).join(' ')
}
